/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()
  const rawPermissions = localStorage.getItem('auth_user_permission')
  const permissionSet = new Set<string>()

  try {
    const parsedPermissions = rawPermissions ? JSON.parse(rawPermissions) : []
    if (Array.isArray(parsedPermissions)) {
      parsedPermissions.forEach((perm) => permissionSet.add(perm.permission_name))
    }
  } catch (error) {
    console.error('Failed to parse permissions:', error)
  }

  // Helper function to check permissions using the Set
  const hasPermission = (permissionName: string): boolean => permissionSet.has(permissionName)


  return (
    
    <>

<div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-1'></div>
        </div>
      </div>

      <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title='Dashboard- Performance'
        // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
      />
        {(hasPermission('dashboard_report_total')) && (
      <AsideMenuItem
        to='/dailyreport/users'
        icon='people'
        title='Dashboard - Total Reporting'
        
      />
       )}

      {(hasPermission('dashboard_report_Daily')) && (
      <AsideMenuItem
        to='/dailyreport/daily'
        icon='people'
        title='Dashboard - Daily Reporting'
        
      />
      )}
      {(hasPermission('dashboard_report_details')) && (
      <AsideMenuItem
        to='/report/details'
        icon='people'
        title='Dashboard - Report Details'
        
      />
      )}

      {/* <AsideMenuItemWithSub to='/apps/clients' title='Manage Clients' icon='people'>
        <AsideMenuItem to='/apps/clients/add' title='Add Client' hasBullet={true} />
        <AsideMenuItem to='/apps/clients/users' title='Clients List' hasBullet={true} />
        <AsideMenuItem to='/apps/clients/daliy-add-client' title='Daily Add Client' hasBullet={true} />
        <AsideMenuItem to='/apps/clients/daliy-client-list' title='Daily Client List' hasBullet={true} />
        <AsideMenuItem to='/apps/clients/daliy-add-spa-client' title='Add Daily SPA Client' hasBullet={true} />
        <AsideMenuItem to='/apps/clients/daliy-spa-client-list' title='View Daily SPA Client' hasBullet={true} />
        
        <AsideMenuItem to='/apps/clients/expirealert' title='Alert Expiring' hasBullet={true} />
      </AsideMenuItemWithSub> */}
       {/* Clients Menu */}
       {(hasPermission('manage_clients_read') || 
       hasPermission('manage_clients_create') ||
       hasPermission('manage_clients_update') || 
       hasPermission('manage_clients_delete') ||
       hasPermission('manage_daily_clients_read') ||
       hasPermission('manage_daily_clients_create') ||
       hasPermission('manage_daily_clients_update') ||
       hasPermission('manage_daily_clients_delete') ||
       hasPermission('manage_daily_spa_clients_read') ||
       hasPermission('manage_daily_spa_clients_create') ||
       hasPermission('manage_daily_spa_clients_update') ||
       hasPermission('manage_daily_spa_clients_delete')) && (
        <AsideMenuItemWithSub to='/apps/clients' title='Manage Clients' icon='people'>
          {hasPermission('manage_clients_create') && (
            <AsideMenuItem to='/apps/clients/add' title='Add Client' hasBullet={true} />
          )}
          {hasPermission('manage_clients_read') && (
            <AsideMenuItem to='/apps/clients/users' title='Clients List' hasBullet={true} />
          )}
          {/* {hasPermission('manage_clients_update') && (
            <AsideMenuItem to='/apps/clients/edit' title='Edit Client' hasBullet={true} />
          )} */}
          {hasPermission('manage_daily_clients_create') && (
            <AsideMenuItem to='/apps/clients/daliy-add-client' title='Daily Add Client' hasBullet={true} />
          )}
          {hasPermission('manage_daily_clients_read') && (
            <AsideMenuItem to='/apps/clients/daliy-client-list' title='Daily Client List' hasBullet={true} />
          )}
          {hasPermission('manage_daily_spa_clients_create') && (
            <AsideMenuItem to='/apps/clients/daliy-add-spa-client' title='Add Daily SPA Client' hasBullet={true} />
          )}
          {hasPermission('manage_daily_spa_clients_read') && (
        <AsideMenuItem to='/apps/clients/daliy-spa-client-list' title='View Daily SPA Client' hasBullet={true} />
          )}
        <AsideMenuItem to='/apps/clients/expirealert' title='Alert Expiring' hasBullet={true} />
      

        </AsideMenuItemWithSub>
      )}
      

      {/* <AsideMenuItem
        to='/crafted'
        icon='shield-tick'
        title='Manage Approvals'
      /> */}

       {/* <AsideMenuItemWithSub to='/apps/expenses' title='Manage Expenses' icon='dollar'>
        <AsideMenuItem to='/apps/expenses/add' title='Add Expense' hasBullet={true} />
        <AsideMenuItem to='/apps/expenses/expenses' title='Expenses List' hasBullet={true} />
      </AsideMenuItemWithSub> */}

       {/* Expenses Menu */}
       {(hasPermission('manage_expenses_create') || 
          hasPermission('manage_expenses_update') || 
          hasPermission('manage_expenses_delete') ||
          hasPermission('manage_expenses_delete')) && (
        <AsideMenuItemWithSub to='/apps/expenses' title='Manage Expenses' icon='dollar'>
          {hasPermission('manage_expenses_create') && (
            <AsideMenuItem to='/apps/expenses/add' title='Add Expense' hasBullet={true} />
          )}
          {hasPermission('manage_expenses_read') && (
            <AsideMenuItem to='apps/expenses/expenses' title='Expenses List' hasBullet={true} />
          )}
        </AsideMenuItemWithSub>
      )}
     
       {/* <AsideMenuItemWithSub to='/apps/membership' title='Manage Packages' icon='star'>
        <AsideMenuItem to='/apps/membership/add' title='Add Package' hasBullet={true} />
        <AsideMenuItem to='/apps/membership/membership' title='Packages List' hasBullet={true} />
      </AsideMenuItemWithSub> */}
       {/* Packages Menu */}
       {(hasPermission('manage_packages_read') || 
       hasPermission('manage_packages_create') ||
       hasPermission('manage_packages_update') ||
       hasPermission('manage_packages_delete')) && (
        <AsideMenuItemWithSub to='/apps/packages' title='Manage Packages' icon='gift'>
          {hasPermission('manage_packages_create') && (
            <AsideMenuItem to='/apps/membership/add' title='Add Package' hasBullet={true} />
          )}
          {hasPermission('manage_packages_read') && (
            <AsideMenuItem to='/apps/membership/membership' title='Packages List' hasBullet={true} />
          )}
        </AsideMenuItemWithSub>
      )}

       {/* <AsideMenuItemWithSub to='/apps/users' title='Manage Users' icon='profile-user'>
        <AsideMenuItem to='/apps/users/add' title='Add User' hasBullet={true} />
        <AsideMenuItem to='/apps/users/users' title='Users List' hasBullet={true} />
        <AsideMenuItem to='/apps/users/roles' title='Roles' hasBullet={true} />
        <AsideMenuItem to='/apps/users/permissions' title='Permissions' hasBullet={true} />
      </AsideMenuItemWithSub> */}
      {(hasPermission('manage_users_read') ||
          hasPermission('manage_users_create') ||
          hasPermission('manage_users_update') ||
          hasPermission('manage_users_delete')) && (
        <AsideMenuItemWithSub to='/apps/users' title='Manage Users' icon='profile-user'>
          {hasPermission('manage_users_create') && (
            <AsideMenuItem to='/apps/users/add' title='Add User' hasBullet={true} />
          )}
          {hasPermission('manage_users_read') && (
            <AsideMenuItem to='/apps/users/users' title='Users List' hasBullet={true} />
          )}
          {/* {hasPermission('manage_users_update') && (
            <AsideMenuItem to='/apps/users/edit' title='Edit User' hasBullet={true} />
          )} */}
          {(hasPermission('manage_role_create') ||
         hasPermission('manage_role_update') ||
         hasPermission('manage_role_read') ) && (
            <AsideMenuItem to='/apps/users/roles' title='Roles' hasBullet={true} />
          )}
           {(hasPermission('manage_role_create') ||
            hasPermission('manage_role_update') ||
            hasPermission('manage_role_read') ) && (
           <AsideMenuItem to='/apps/users/permissions' title='Permissions' hasBullet={true} />
          )}
          
          {/* <AsideMenuItem to='/apps/users/roles' title='Roles' hasBullet={true} /> */}
          {/* <AsideMenuItem to='/apps/users/permissions' title='Permissions' hasBullet={true} /> */}
      
        </AsideMenuItemWithSub>
      )}


      {(hasPermission('manage_approval_read') ||
        hasPermission('manage_approval_approve') ||
        hasPermission('manage_approval_reject')) && (
          <AsideMenuItemWithSub to='/approval' title='Approval Management' icon='star'>
            {hasPermission('manage_approval_read') && (
            <AsideMenuItem to='/approval/users' title='Approval List' hasBullet={true} />
            )}
          </AsideMenuItemWithSub>
      )}
        <AsideMenuItemWithSub to='/attendance' title='Attendance Management' icon='user'>
            
            <AsideMenuItem to='/attendance/users' title='Attendance List' hasBullet={true} />
            <AsideMenuItem to='/attendance/devices' title='Attendance Devices' hasBullet={true} />
          
          </AsideMenuItemWithSub>
     {/*  <AsideMenuItem
        to='/crafted'
        icon='notification'
        title='Manage Alerts'
      />
      <AsideMenuItem
        to='/crafted'
        icon='tablet-text-up'
        title='Reports'
      /> */}

      

    

     

 
      
     {/*  <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <AsideMenuItem to='/builder' icon='switch' title='Layout Builder' />
      <AsideMenuItemWithSub to='/crafted/pages' title='Pages' icon='gift'>
        <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
          <AsideMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <AsideMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='/crafted/accounts' title='Accounts' icon='profile-circle'>
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='/error' title='Errors' icon='cross-circle'>
        <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='/crafted/widgets' title='Widgets' icon='element-plus'>
        <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <AsideMenuItemWithSub to='/apps/chat' title='Chat' icon='message-text-2'>
        <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem to='/apps/user-management/users' icon='shield-tick' title='User management' />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>   */}
      
    </>
  )
}
